import React from 'react';
const CART_URL = 'https://fbwqku-s9.myshopify.com/cart/52013268271396:1';
export function SalesLetterSection() {
  return <section className="bg-amber-50 py-12 md:py-16 px-4" data-id="element-126">
      <div className="container mx-auto max-w-3xl" data-id="element-127">
        <article className="prose prose-stone prose-lg max-w-none" data-id="element-128">
          {/* Story Section */}
          <div className="space-y-6 text-stone-700 text-base md:text-lg leading-relaxed" data-id="element-129">
            <p className="font-semibold text-pink-600 text-xl" data-id="element-130">
              Sé exactamente cómo te sientes...
            </p>

            <p data-id="element-131">
              Cada mes es la misma historia: el dinero no alcanza. Las cuentas
              se acumulan, los gastos sorpresa aparecen de la nada, y esa
              sensación de estar siempre al límite te acompaña día tras día.
            </p>

            <p data-id="element-132">
              Quieres emprender. Sueñas con tener tu propio negocio, con generar
              tus propios ingresos, con no depender de nadie más. Pero cada vez
              que lo piensas, te frenas...
            </p>

            <p className="text-rose-500 font-bold text-lg" data-id="element-133">
              ¿Y si la inversión es muy alta? ¿Y si no funciona? ¿Y si pierdo el
              poco dinero que tengo?
            </p>

            {/* Identification Section */}
            <div className="bg-white border-l-4 border-rose-400 p-6 my-8 rounded-r-lg shadow-md" data-id="element-134">
              <p className="font-bold text-pink-600 text-xl mb-4" data-id="element-135">
                ¿Te identificas con esto?
              </p>
              <ul className="space-y-3 text-stone-700" data-id="element-136">
                <li className="flex items-start gap-3" data-id="element-137">
                  <span className="text-rose-500 font-bold" data-id="element-138">✗</span>
                  <span data-id="element-139">
                    El dinero nunca alcanza y vives contando cada peso.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-140">
                  <span className="text-rose-500 font-bold" data-id="element-141">✗</span>
                  <span data-id="element-142">
                    Quieres emprender pero el miedo a perder dinero te paraliza.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-143">
                  <span className="text-rose-500 font-bold" data-id="element-144">✗</span>
                  <span data-id="element-145">Pensás en la inversión inicial y te da vértigo.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-146">
                  <span className="text-rose-500 font-bold" data-id="element-147">✗</span>
                  <span data-id="element-148">
                    No querés otro "cursito más" que termine juntando polvo
                    digital.
                  </span>
                </li>
              </ul>
            </div>

            <p className="font-semibold text-pink-600 text-xl" data-id="element-149">
              Ya probaste con velas... con repostería... con mil cosas
            </p>

            <p data-id="element-150">Y seguramente te pasó esto:</p>

            <div className="bg-white rounded-lg p-6 space-y-4 shadow-md" data-id="element-151">
              <div data-id="element-152">
                <p className="font-bold text-rose-500 mb-2" data-id="element-153">Las velas:</p>
                <p className="text-stone-700" data-id="element-154">
                  Gastaste en moldes, parafina, esencias... y después no
                  vendiste casi nada. La competencia es brutal y los precios
                  están por el piso.
                </p>
              </div>
              <div data-id="element-155">
                <p className="font-bold text-rose-500 mb-2" data-id="element-156">
                  Otros emprendimientos:
                </p>
                <p className="text-stone-700" data-id="element-157">
                  Te metiste en algo que necesitaba mucho stock, mucha plata
                  inicial, o que era demasiado complicado para arrancar.
                </p>
              </div>
              <div data-id="element-158">
                <p className="font-bold text-rose-500 mb-2" data-id="element-159">
                  Cursos que compraste:
                </p>
                <p className="text-stone-700" data-id="element-160">
                  Pagaste por información que nunca aplicaste porque era muy
                  teórica o muy complicada.
                </p>
              </div>
            </div>

            <p className="text-2xl font-extrabold text-pink-600 text-center my-8" data-id="element-161">
              El problema NO eres vos. El problema es que nadie te mostró algo
              SIMPLE, RENTABLE y con BAJA inversión.
            </p>

            {/* Solution Introduction */}
            <div className="bg-gradient-to-r from-pink-400 to-rose-400 rounded-xl p-8 my-10 text-center shadow-xl" data-id="element-162">
              <p className="text-3xl md:text-4xl font-extrabold text-white mb-4" data-id="element-163">
                Ahora existe una forma DIFERENTE
              </p>
            </div>

            <p className="font-semibold text-pink-600 text-xl" data-id="element-164">
              Imaginate esto...
            </p>

            <p data-id="element-165">
              En menos de 24 horas aprendés a hacer{' '}
              <span className="text-rose-500 font-bold" data-id="element-166">
                Placas Aromáticas Artesanales
              </span>{' '}
              - un producto innovador que está arrasando en el mercado y que la
              gente compra como pan caliente.
            </p>

            <p data-id="element-167">
              No necesitás años de experiencia. No necesitás una inversión
              enorme. No necesitás un local.
            </p>

            <p className="text-xl font-bold text-rose-500" data-id="element-168">
              Solo necesitás ganas de empezar y 24 horas para cambiar tu
              situación económica.
            </p>

            {/* Benefits List */}
            <div className="bg-white rounded-lg p-6 my-8 shadow-md" data-id="element-169">
              <p className="font-bold text-pink-600 text-xl mb-4" data-id="element-170">
                En menos de 24 horas vas a poder:
              </p>
              <ul className="space-y-3 text-stone-700" data-id="element-171">
                <li className="flex items-start gap-3" data-id="element-172">
                  <span className="text-pink-500 font-bold" data-id="element-173">✓</span>
                  <span data-id="element-174">
                    Hacer tus primeras Placas Aromáticas profesionales (paso a
                    paso, sin vueltas).
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-175">
                  <span className="text-pink-500 font-bold" data-id="element-176">✓</span>
                  <span data-id="element-177">
                    Generar tus primeros ingresos REALES vendiendo un producto
                    que la gente AMA.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-178">
                  <span className="text-pink-500 font-bold" data-id="element-179">✓</span>
                  <span data-id="element-180">
                    Empezar con inversión mínima - no necesitás miles de pesos
                    para arrancar.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-181">
                  <span className="text-pink-500 font-bold" data-id="element-182">✓</span>
                  <span data-id="element-183">
                    Tener acceso a los mejores proveedores para que no pierdas
                    tiempo ni dinero buscando.
                  </span>
                </li>
              </ul>
            </div>

            {/* Why Different */}
            <p className="font-semibold text-pink-600 text-2xl text-center my-8" data-id="element-184">
              ¿Por qué las Placas Aromáticas son diferentes?
            </p>

            <p className="text-center mb-6" data-id="element-185">
              Porque combinan TODO lo que necesitás para emprender bien:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-8" data-id="element-186">
              <div className="bg-white border-2 border-pink-300 rounded-lg p-5 shadow-md" data-id="element-187">
                <p className="font-bold text-rose-500 mb-2" data-id="element-188">Fáciles de hacer</p>
                <p className="text-stone-700 text-sm" data-id="element-189">
                  No necesitás ser un chef ni tener habilidades manuales
                  complejas.
                </p>
              </div>
              <div className="bg-white border-2 border-pink-300 rounded-lg p-5 shadow-md" data-id="element-190">
                <p className="font-bold text-rose-500 mb-2" data-id="element-191">Inversión mínima</p>
                <p className="text-stone-700 text-sm" data-id="element-192">
                  Empezás con poco y vas creciendo a medida que vendés.
                </p>
              </div>
              <div className="bg-white border-2 border-pink-300 rounded-lg p-5 shadow-md" data-id="element-193">
                <p className="font-bold text-rose-500 mb-2" data-id="element-194">
                  Producto innovador
                </p>
                <p className="text-stone-700 text-sm" data-id="element-195">
                  No es "otra vela más" - son placas aromáticas que están de
                  moda.
                </p>
              </div>
              <div className="bg-white border-2 border-pink-300 rounded-lg p-5 shadow-md" data-id="element-196">
                <p className="font-bold text-rose-500 mb-2" data-id="element-197">Se vende rápido</p>
                <p className="text-stone-700 text-sm" data-id="element-198">
                  La gente las BUSCA porque son decorativas, funcionales y
                  duran.
                </p>
              </div>
              <div className="bg-white border-2 border-pink-300 rounded-lg p-5 shadow-md" data-id="element-199">
                <p className="font-bold text-rose-500 mb-2" data-id="element-200">
                  Alta rentabilidad
                </p>
                <p className="text-stone-700 text-sm" data-id="element-201">
                  Tus márgenes de ganancia son EXCELENTES comparado con otros
                  productos.
                </p>
              </div>
            </div>

            {/* Objection Handling */}
            <div className="bg-white border-l-4 border-amber-400 p-6 my-10 rounded-r-lg shadow-md" data-id="element-202">
              <p className="font-bold text-amber-600 text-xl mb-4" data-id="element-203">
                "Pero... ¿y si no me sale?"
              </p>
              <p className="text-stone-700 mb-4" data-id="element-204">
                Te entiendo. El miedo a fallar es real. Pero dejame decirte
                algo:
              </p>
              <p className="text-pink-600 font-semibold mb-4" data-id="element-205">
                Este curso está diseñado para que CUALQUIER persona pueda
                hacerlo. No necesitás experiencia previa. No necesitás ser
                "buena con las manos".
              </p>
              <p className="text-stone-700 mb-4" data-id="element-206">
                Te muestro PASO A PASO cómo hacerlo. Y si tenés dudas, tenés
                soporte para preguntarme lo que necesites.
              </p>
              <p className="text-rose-500 font-bold text-lg" data-id="element-207">
                Si otras mujeres sin experiencia lo lograron, vos también podés.
              </p>
            </div>

            {/* Final Decision */}
            <div className="text-center my-12" data-id="element-208">
              <p className="text-3xl md:text-4xl font-extrabold text-pink-600 mb-8" data-id="element-209">
                Llegó el momento de decidir
              </p>
              <p className="text-xl text-stone-700 mb-6" data-id="element-210">
                Tenés dos caminos frente a vos:
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-211">
                <div className="bg-white border-2 border-rose-300 rounded-lg p-6 shadow-md" data-id="element-212">
                  <p className="font-bold text-rose-500 text-lg mb-3" data-id="element-213">
                    Opción 1:
                  </p>
                  <p className="text-stone-700" data-id="element-214">
                    Seguir como hasta ahora. Que el dinero no alcance. Que el
                    miedo te paralice. Que otro mes más pase sin que cambies
                    nada.
                  </p>
                </div>
                <div className="bg-white border-2 border-pink-400 rounded-lg p-6 shadow-md" data-id="element-215">
                  <p className="font-bold text-pink-600 text-lg mb-3" data-id="element-216">
                    Opción 2:
                  </p>
                  <p className="text-stone-700" data-id="element-217">
                    Dar el paso HOY. Invertir en vos misma. Aprender algo NUEVO
                    que realmente funciona. Empezar a generar tus propios
                    ingresos en menos de 24 horas.
                  </p>
                </div>
              </div>

              <a href={CART_URL} className="inline-block w-full max-w-2xl bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-extrabold text-xl md:text-2xl uppercase px-8 py-6 rounded-lg shadow-2xl transition-all duration-200 animate-pulse-urgent border-4 border-pink-600" data-id="element-218">
                👉 CLICK AQUÍ PARA ACCEDER A LA OFERTA ESPECIAL 👈
              </a>
            </div>

            {/* Final Message */}
            <div className="bg-gradient-to-r from-white to-pink-50 rounded-xl p-8 my-10 shadow-md" data-id="element-219">
              <p className="font-bold text-pink-600 text-2xl mb-4" data-id="element-220">
                Una última cosa...
              </p>
              <p className="text-stone-700 mb-4" data-id="element-221">
                Sé que tal vez estés cansada de promesas vacías. De cursos que
                no cumplen. De "oportunidades" que te dejaron con las manos
                vacías.
              </p>
              <p className="text-pink-600 font-semibold mb-4" data-id="element-222">
                Pero esto es diferente.
              </p>
              <p className="text-stone-700 mb-4" data-id="element-223">
                Esto no es teoría. Es un método probado. Es un producto que se
                vende. Es una oportunidad REAL para que empieces a generar
                ingresos desde casa.
              </p>
              <p className="text-rose-500 font-bold text-xl mb-4" data-id="element-224">
                No te estoy vendiendo un sueño. Te estoy dando las herramientas
                para que lo construyas vos misma.
              </p>
              <p className="text-pink-600 font-extrabold text-2xl text-center" data-id="element-225">
                La pregunta es: ¿Estás lista para empezar?
              </p>
            </div>
          </div>
        </article>
      </div>
    </section>;
}